import React, {memo} from "react";

const Contact = (props: any) => {
    return (
        <section id={`Contact`} className={'bg-gray-50 pt-12 pb-32'}>
            <h3 className={`text-3xl text-center`}>Contact Me</h3>
            <p className={`text-lg mb-20 text-gray-500 text-center`}>How to get in touch?</p>
            <div className={`flex flex-wrap gap-1 px-32`}>
                <div className={`flex text-center w-full lg:w-[33%] flex-col items-center justify-center`}>
                    <i className="text-blue-800 bi bi-envelope-fill bg-white w-16 h-16 flex items-center justify-center text-4xl border-2 border-solid border-blue-800 rounded-[50%]" />
                    <h4 className="text-2xl font-bold mt-3">Email</h4>
                    <p>omar.dev.work@outlook.com</p>
                </div>
                <div className={`flex text-center w-full lg:w-[33%] flex-col items-center justify-center`}>
                    <i className="text-blue-800 bi bi-telegram bg-white w-16 h-16 flex items-center justify-center text-4xl border-2 border-solid border-blue-800 rounded-[50%]" />
                    <h4 className="text-2xl font-bold mt-3">Telegram</h4>
                    <p>@OmarWebDev</p>
                </div>
                <div className={`flex text-center w-full lg:w-[33%] flex-col items-center justify-center`}>
                    <i className="text-blue-800 bi bi-telephone-fill bg-white w-16 h-16 flex items-center justify-center text-4xl border-2 border-solid border-blue-800 rounded-[50%]" />
                    <h4 className="text-2xl font-bold mt-3">Phone</h4>
                    <p>+201555115829</p>
                </div>
            </div>
        </section>
    )
}
export default memo(Contact)